import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import UsersList from './Details/Users.component';
import BreadCrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import AuthCheckManager from '../../Utils/AuthCheck/ManagerCheck.auth';
import CourseList from './Details/Courses.component';
import CompanyPurchaseDetails from './CheckoutDetails.component';
import {
  CompanyPurchaseLeft,
  CompanyPurchasePage,
  CompanyPurchaseRight,
} from './CompanyBuy.styles';
import LoadingCompanyPurchasePage from '../../Components/LoadingPages/LoadingCompanyBuy.component';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import CoursesDataProvider from '../../Utils/Courses/CoursesDataProvider';
import CompanyDataProvider from '../../Utils/Companies/CompanyDataProvider';

const CompanyPurchaseCourses = () => {
  const { companyId } = useParams();
  const [selectedCourse, setSelectedCourse] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);

  return (
    <>
      <AuthCheckManager>
        <HelmetHelper
          title="Purchase Courses"
          description="Purchase course for company employees"
        />
        <CompanyPurchasePage>
          <CompanyDataProvider
            id={companyId}
            loadingComponent={LoadingCompanyPurchasePage}
          >
            {({ users, company, address }) => {
              return (
                <CoursesDataProvider>
                  {(courses) => {
                    return (
                      <>
                        <CompanyPurchaseLeft>
                          <BreadCrumbs
                            one="Company Dashboard"
                            oneLink={'/company'}
                            two="Purchase Courses"
                          />
                          <h2>Purchase Course</h2>
                          <CourseList
                            courses={courses}
                            selectedCourse={selectedCourse}
                            setSelectedCourse={setSelectedCourse}
                          />
                          <UsersList
                            users={users}
                            courseId={selectedCourse?._id}
                            selectedUsers={selectedUsers}
                            setSelectedUsers={setSelectedUsers}
                          />
                        </CompanyPurchaseLeft>
                        <CompanyPurchaseRight>
                          <CompanyPurchaseDetails
                            course={selectedCourse}
                            users={selectedUsers}
                            company={company?.[0] || {}}
                            address={address}
                            companyId={companyId}
                          />
                        </CompanyPurchaseRight>
                      </>
                    );
                  }}
                </CoursesDataProvider>
              );
            }}
          </CompanyDataProvider>
        </CompanyPurchasePage>
      </AuthCheckManager>
    </>
  );
};

export default CompanyPurchaseCourses;
